export class TemplateVarModel {

  id?: number;
  corpo = '';
  variaveis: TemplateVariavel[] = [];

}

export class TemplateVariavel{

  id?: number;
  numero?: number;
  variavel?: string;
  tipoCampoFixo?: string;

}
